import React, {Component} from "react"
import Radio from "@material-ui/core/Radio";
import {toast} from "react-toastify";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import {isMobile} from "../Utilities/OtherUtils";
import {CancelButton, SubmitButton} from "../Common/Buttons";

/**
 * To be filled by chairs after events for scoring and assessing juniors' performances
 */
const hasDuplicates = arr => arr.some((item, index) => item !== "-1" && arr.indexOf(item) !== index);

export class PositionsForm extends Component {

    constructor(props) {
        super(props);
        this.handleTeamRankChange = this.handleTeamRankChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.clearAll = this.clearAll.bind(this);
    }

    clearAll() {
        this.props.ranks = ["-1", "-1", "-1", "-1"];
        this.props.onChange();
    }

    handleSubmit() {
        if (hasDuplicates(this.props.ranks)) {
            toast.error("Cannot give 2 or more teams the same rank");
        } else {
            this.props.onFinish();
        }
    }

    handleTeamRankChange(event, position) {
        this.props.ranks[position] = event.target.value;
        this.props.onChange();
    }

    getTeamNames(record, position) {
        let teamNames = record.filter(x => x[1].position === position).map(x => x[1].full_name_eng.split(" ")[0]).join(" & ");
        if (teamNames === "") {
            return "None";
        }
        return teamNames;
    }

    render() {
        const radioStyle = {padding: 0, margin: 0, width: isMobile() ? 10 : 25};
        let record = Object.entries(this.props.record);
        let og = this.getTeamNames(record, "Opening Government");
        let oo = this.getTeamNames(record, "Opening Opposition");
        let cg = this.getTeamNames(record, "Closing Government");
        let co = this.getTeamNames(record, "Closing Opposition");
        return (
            <div align={"left"}>
                <h2 style={{marginLeft: 10}}>Positions</h2>
                <br/>
                <FormControl component="fieldset">

                    <br/><label style={{marginLeft: 10}}>Opening Government ({og}):</label><br/>
                    <RadioGroup
                        name="og"
                        style={{display: 'inline'}}
                        value={this.props.ranks[0]}
                        onChange={(e) => this.handleTeamRankChange(e, 0)}
                        row>

                        <FormControlLabel
                            value="1"
                            control={<Radio style={radioStyle}/>}
                            label="1st"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="2"
                            control={<Radio style={radioStyle}/>}
                            label="2nd"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="3"
                            control={<Radio style={radioStyle}/>}
                            label="3rd"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="4"
                            control={<Radio style={radioStyle}/>}
                            label="4th"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="-1"
                            control={<Radio style={radioStyle}/>}
                            label="Not Present"
                            labelPlacement="bottom"
                        />
                    </RadioGroup>
                </FormControl>
                <br/>
                <FormControl component="fieldset">

                    <br/><label style={{marginLeft: 10}}>Opening Opposition ({oo}):</label><br/>
                    <RadioGroup
                        name="oo"
                        style={{display: 'inline'}}
                        value={this.props.ranks[1]}
                        onChange={(e) => this.handleTeamRankChange(e, 1)}
                        row>

                        <FormControlLabel
                            value="1"
                            control={<Radio style={radioStyle}/>}
                            label="1st"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="2"
                            control={<Radio style={radioStyle}/>}
                            label="2nd"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="3"
                            control={<Radio style={radioStyle}/>}
                            label="3rd"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="4"
                            control={<Radio style={radioStyle}/>}
                            label="4th"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="-1"
                            control={<Radio style={radioStyle}/>}
                            label="Not Present"
                            labelPlacement="bottom"
                        />
                    </RadioGroup>
                </FormControl>
                <br/>
                <FormControl component="fieldset">

                    <br/><label style={{marginLeft: 10}}>Closing Government ({cg}):</label><br/>
                    <RadioGroup
                        name="cg"
                        style={{display: 'inline'}}
                        value={this.props.ranks[2]}
                        onChange={(e) => this.handleTeamRankChange(e, 2)}
                        row>

                        <FormControlLabel
                            value="1"
                            control={<Radio style={radioStyle}/>}
                            label="1st"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="2"
                            control={<Radio style={radioStyle}/>}
                            label="2nd"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="3"
                            control={<Radio style={radioStyle}/>}
                            label="3rd"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="4"
                            control={<Radio style={radioStyle}/>}
                            label="4th"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="-1"
                            control={<Radio style={radioStyle}/>}
                            label="Not Present"
                            labelPlacement="bottom"
                        />
                    </RadioGroup>
                </FormControl>
                <br/>
                <FormControl component="fieldset">

                    <br/><label style={{marginLeft: 10}}>Closing Opposition ({co}):</label><br/>
                    <RadioGroup
                        name="co"
                        style={{display: 'inline'}}
                        value={this.props.ranks[3]}
                        onChange={(e) => this.handleTeamRankChange(e, 3)}
                        row>

                        <FormControlLabel
                            value="1"
                            control={<Radio style={radioStyle}/>}
                            label="1st"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="2"
                            control={<Radio style={radioStyle}/>}
                            label="2nd"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="3"
                            control={<Radio style={radioStyle}/>}
                            label="3rd"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="4"
                            control={<Radio style={radioStyle}/>}
                            label="4th"
                            labelPlacement="bottom"
                        />
                        <FormControlLabel
                            value="-1"
                            control={<Radio style={radioStyle}/>}
                            label="Not Present"
                            labelPlacement="bottom"
                        />
                    </RadioGroup>
                </FormControl>
                <br/>

                <div align="center">
                    <CancelButton onClick={this.clearAll} label={"Clear"}/>
                    <SubmitButton onClick={this.handleSubmit}/>
                </div>
                <br/>
                <br/>
            </div>
        );
    }

}
